import type { Components, Theme } from '@mui/material';
import { fontWeights } from '@/@mui/tokens/font-weights';

export const MuiFormLabel: Components<Theme>['MuiFormLabel'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.neutral.darker,
      fontWeight: fontWeights.fontWeightSemibold,
      marginBottom: theme.spacing(1),

      '&.Mui-focused': {
        color: theme.palette.neutral.darker,
      },
    }),
  },
};
